// build 2026-09-03b — hash rotation to evict wedged partial downloads
// First, for its side effect: every API request carries X-App-Build.
import './utils/appBuild';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import { initSentry } from './sentry';
import './index.css';
import App from './App';
import AppErrorBoundary from './components/AppErrorBoundary';
import { ConfirmProvider } from './components/ui/ConfirmProvider';
import { ToastHost } from './components/ui/toast';

// Before render, so a crash during the first paint is still reported.
initSentry();

const root = createRoot(document.getElementById('root'));

root.render(
    <AppErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <ConfirmProvider>
            <App />
            <ToastHost />
          </ConfirmProvider>
        </AuthProvider>
      </BrowserRouter>
    </AppErrorBoundary>
);